import { apiClient } from '@/lib/api/client'

export interface TicketRequestSourceEmail {
  subject: string | null
  body: string
  received_email_id: number
}

export async function getTicketRequestSourceEmail(
  ticketRequestId: number
): Promise<TicketRequestSourceEmail> {
  const { data } = await apiClient.get<{ data: TicketRequestSourceEmail }>(
    `/support/my-request/${ticketRequestId}/source-email`,
    { timeout: 45000 }
  )
  return data.data
}
